module.exports = __webpack_public_path__ + "img/client-7.b462c0e6.png";